import type { CodeSystem } from '@medplum/fhirtypes'
import { matchesSearchTerms, searchTerms, textTerms } from '#src/searchTerms.ts'
import { ASSESSMENT_QUESTIONS_SYSTEM } from '#src/terminology/types.ts'

// Named as LOINC names it: a code carrying a scale can be recorded on its own.
const SCALE_PROPERTY = 'SCALE_TYP'

export interface CapturableQuestion {
  system: string
  code: string
  display: string
  // The question as it is asked, which says more than the short display.
  definition?: string
}

// The question codes that can be recorded as an observation on their own,
// narrowed to those where every term of `search` starts a word of the code,
// display or definition, so "priority of care" finds "Priorities of care".
export function capturableQuestions(
  codeSystem: CodeSystem,
  search = ''
): CapturableQuestion[] {
  const terms = searchTerms(search)
  return (codeSystem.concept ?? [])
    .filter((concept) =>
      concept.property?.some((property) => property.code === SCALE_PROPERTY)
    )
    .map((concept) => {
      const question: CapturableQuestion = {
        system: ASSESSMENT_QUESTIONS_SYSTEM,
        code: concept.code,
        display: concept.display ?? concept.code,
      }
      if (concept.definition) {
        question.definition = concept.definition
      }
      return question
    })
    .filter((question) =>
      matchesSearchTerms(
        terms,
        textTerms(
          `${question.code} ${question.display} ${question.definition ?? ''}`
        )
      )
    )
}
